import {styled} from '@mui/material/styles';
import React, {useCallback, useState} from 'react';
import {PieChart, Pie, Sector, Legend, ResponsiveContainer} from 'recharts';

import {pxToRem} from '../../utils';

const StyledResponsiveContainer = styled(ResponsiveContainer)(({theme}) => ({
  borderRadius: pxToRem(8),
  background: theme.palette.white,
  boxShadow: theme.palette.boxShadow?.type2,
}));

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const {cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value} = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle">
        {payload.key}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${value}`}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
        {`(${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

export default function PlotPieChart({titleInfo, chartData, innerRadius, outerRadius}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const onPieEnter = useCallback(
    (_, index) => {
      setActiveIndex(index);
    },
    [setActiveIndex]
  );
  const renderColorfulLegendText = (index, chart) => {
    return (
      <span
        style={{color: '#596579', fontWeight: 500, paddingRight: '40px'}}
      >{`${chart?.payload?.key} (${chart?.payload?.value})`}</span>
    );
  };
  return (
    <StyledResponsiveContainer width="100%" height={400}>
      <PieChart>
        <Legend
          iconType="circle"
          layout="vertical"
          align="right"
          verticalAlign="middle"
          iconSize={10}
          formatter={renderColorfulLegendText}
        />
        <Pie
          activeIndex={activeIndex}
          activeShape={renderActiveShape}
          data={chartData?.data || []}
          cx="50%"
          cy="50%"
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          dataKey="value"
          onMouseEnter={onPieEnter}
        />
        <text
          x={titleInfo?.xPercent || '10%'}
          y="1%"
          textAnchor="end"
          dominantBaseline="hanging"
          style={{fontWeight: 'bold', fontSize: '24px', fill: '#333'}}
        >
          {' '}
          {titleInfo?.text || ''}
        </text>
        <text
          x="99%"
          y="1%"
          textAnchor="end"
          dominantBaseline="hanging"
          style={{fontWeight: 'bold', fontSize: '16px', fill: '#333'}}
        >
          Total: {chartData?.totalCount || 0}
        </text>
        {chartData?.totalCount === 0 ? (
          <text
            x="60%"
            y="50%"
            textAnchor="end"
            dominantBaseline="hanging"
            style={{fontWeight: 'bold', fontSize: '16px', fill: '#333'}}
          >
            No Records Found
          </text>
        ) : null}
      </PieChart>
    </StyledResponsiveContainer>
  );
}
